import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spin, Typography, message } from 'antd';
import api from '../../services/apiService';
import { useAuth } from '../../contexts/AuthContext';
import { exchangeOpsBridgeToken } from '../../services/opsService';

export default function OpsAuthPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [erro, setErro] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setErro('Token de acesso não informado.');
      return;
    }
    (async () => {
      try {
        const data = await exchangeOpsBridgeToken(token);
        localStorage.setItem('access_token', data.access);
        localStorage.setItem('refresh_token', data.refresh);
        api.defaults.headers.common['Authorization'] = `Bearer ${data.access}`;
        await refreshUser();
        message.success('Acesso ao painel de gestão concedido.');
        navigate('/ops', { replace: true });
      } catch {
        setErro('Não foi possível autenticar. Volte ao admin e tente novamente.');
      }
    })();
  }, [searchParams, navigate, refreshUser]);

  if (erro) {
    return <Typography.Text type="danger">{erro}</Typography.Text>;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
      <Spin size="large" tip="Conectando ao painel de gestão..." />
    </div>
  );
}
